//import en from './en';
import ja from "./ja";

const lang = ja;

export default function i18nLocale(key = "", count = 0) {
  const target = Object.keys(lang).find(item => (item.toUpperCase() === key.toUpperCase()));
  if (!target) {
    return key;
  }
  const item = lang[target];
  if (typeof item === "object") {
    return count > 1 ? item.plural : item.singular;
  } else if (typeof item === "function") {
    return item(count);
  }
  return item;
}
